import accounting from 'accounting';
import Bignumber from 'bignumber.js';

export default {
  // characterAndNumberAllowed(input){
  //   let reg = /^[a-zA-Z0-9 '"-]*$/;
  //   var inputLength = '';
  //   if(input.length == 0){
  //     inputLength = false
  //   } else { inputLength = true }
  //   let regTestResult = reg.test(input);
  //   if(inputLength && regTestResult){
  //     return true;
  //   } else { return false }
  // },
  // exclusiveNumberOnly(input){
  //   let reg = /^[0-9]*$/
  //   return reg.test(input);
  // },
  // thousandSeparator(value, fixed=0, separator=".", decimal=","){
  //   if (value){
  //     value = value.toString();
  //     let splittedValue = value.split(decimal);
  //     if (splittedValue.length > 1) { value = splittedValue[0] }
  //     let val = accounting.unformat(value);
  //       val = new Bignumber(val);
  //       val = accounting.formatNumber(val.toString(), fixed, separator,  decimal);
  //     if (splittedValue.length > 1) { val = val + decimal + splittedValue[1] }
  //     return val;
  //   } else return "0";
  // }
}
